const getDefaultState = () => {
  return {
    rounds: [],
    selectedRound: null
  };
};

const state = getDefaultState();

const getters = {
  selectedRound (state) {
    return state.selectedRound;
  },
  rounds (state) {
    return state.rounds;
  }
};

const mutations = {
  setRounds (state, payload) {
    state.rounds = payload;
  },
  setSelectedRound (state, payload) {
    state.selectedRound = payload;
  },
  addRound (state, payload) {
    state.rounds.push(payload);
  },
  resetRounds (state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  callSetSelectedRound (context, payload) {
    context.commit('setSelectedRound', payload);
  },
  callAddRound (context, payload) {
    context.commit('addRound', payload);
  },
  callSetRounds (context, payload) {
    context.commit('setRounds', payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/rounds.js